export const priceWithDiscount = (price, discount) => {
  var numVal1 = parseInt(price);
  var numVal2 = parseFloat(discount) / 100;

  var totalValue = numVal1 - numVal1 * numVal2;
  return totalValue.toFixed(0);
};
